import { render, staticRenderFns } from "./DepartamentoPessoalLista.vue?vue&type=template&id=60651805&scoped=true"
import script from "./DepartamentoPessoalLista.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60651805",
  null
  
)

export default component.exports